import { useMutation } from "@tanstack/react-query";
import axiosInstance from "utils/axios";

export async function getSubjects({ subjects }) {
  return axiosInstance.post("subjects/getSubjectsList", { subjects })
    .then((res) => res.data)
    .catch((err) => err.response);
}

export async function addUserToWatchList({ courseId }) {
  return axiosInstance.post("courses/addUserToWatchList", { courseId })
    .then((res) => res.data)
    .catch((err) => err.response);
}

export async function addUserAnswer({ id, option }) {
  return axiosInstance.post("questions/addUserAnswer", { id, option })
    .then((res) => res.data)
    .catch((err) => err.response);
}

export const useAddUserAnswer = () => {
  return useMutation({
    mutationFn: (data) => addUserAnswer(data),
    // onSuccess: () => {
    //   queryClient.invalidateQueries("userAnswers");
    // },
  });
}